import { render, staticRenderFns } from "./ImagenInfograficaB.vue?vue&type=template&id=4427bdfe&lang=pug&"
import script from "./ImagenInfograficaB.vue?vue&type=script&lang=js&"
export * from "./ImagenInfograficaB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports